module.exports = function(app){

    app.directive('ribbonRating', function(){

        return{
            restrict: 'A',
            replace: false,
            scope: {
                ribbonRating: '=',
                outOf: '=?'
            },
            controller: ['$scope', function($scope){
                $scope.outOf = $scope.outOf || 3;
            }],
            link: function(scope, element){
                var html='', i;

                for (i=0; i < scope.outOf; i++){
                    if(i < scope.ribbonRating){
                        html += '<span style="position: relative"><img src="/bootstrap/v4/resources/img/ribbonBlue.png" alt="blue ribbon"/></span></span>';
                    }
                    else{
                        html += '<span style="position: relative"><img src="/bootstrap/v4/resources/img/ribbonGray.png" alt="gray ribbon"/></span>';
                    }
                }

                element.append(angular.element(html));
            }
        };
    });
};